import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';
import {
  form,
  FormField,
  FormOptions,
  FormRoot,
  minLength,
  pattern,
  required,
  SchemaPathTree,
  TreeValidationResult,
  validate,
} from '@angular/forms/signals';
import { RouterLink } from '@angular/router';
import { PasswordVisibilityToggleComponent } from 'src/app/shared/components/password-visibility-toggle/password-visibility-toggle.component';
import { TranslatePipe } from '@ngx-translate/core';
import { FormFieldOnErrorDirective } from 'src/app/shared/directives/form-field-on-error/form-field-on-error.directive';
import { SignalFormService } from 'src/app/shared/services/signal-form/signal-form.service';
import { PASSWORD_PATTERN } from 'src/app/shared/utils/utils';
import { ResetPasswordFormStepModel } from './reset-password-form-step.model';

@Component({
  selector: 'app-reset-password-form-step',
  templateUrl: './reset-password-form-step.component.html',
  styleUrls: ['./reset-password-form-step.component.scss'],
  imports: [
    PasswordVisibilityToggleComponent,
    TranslatePipe,
    RouterLink,
    FormField,
    FormRoot,
    FormFieldOnErrorDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ResetPasswordFormStepComponent {
  public passwordSubmit = output<string>();

  public revealPassword = signal(false);

  formModel = signal<ResetPasswordFormStepModel>({ password: '', confirmPassword: '' });
  formOptions: FormOptions<ResetPasswordFormStepModel> = SignalFormService.formSubmitOptions(
    this.submitPassword.bind(this),
  );
  form = form(this.formModel, this.#formValidation.bind(this), this.formOptions);

  public togglePasswordVisibility(): void {
    this.revealPassword.update((value) => !value);
  }

  public async submitPassword(): Promise<TreeValidationResult> {
    this.passwordSubmit.emit(this.formModel().password);
    return undefined;
  }

  #formValidation(path: SchemaPathTree<ResetPasswordFormStepModel>): void {
    required(path.password);
    minLength(path.password, 8);
    pattern(path.password, PASSWORD_PATTERN);

    required(path.confirmPassword);
    minLength(path.confirmPassword, 8);
    validate(path.confirmPassword, ({ value, valueOf }) => {
      if (value() !== valueOf(path.password)) {
        return { kind: 'mustMatch', message: 'Passwords do not match' };
      }
      return null;
    });
  }
}
